import { useState, useEffect } from "react";
import { subscribeToLeadsList } from "../services/leads.service";
import { mapLeadsListItem } from "../utils/firebaseLeadsMapper";

export function useLeadsList() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let unsubscribe;

    try {
      unsubscribe = subscribeToLeadsList((raw) => {
        const mapped = Object.entries(raw).map(([waId, data]) =>
          mapLeadsListItem(waId, data)
        );
        mapped.sort((a, b) => b.updatedAt - a.updatedAt);
        setLeads(mapped);
        setLoading(false);
      });
    } catch (err) {
      setError(err);
      setLoading(false);
    }

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  return { leads, loading, error };
}
